import {Injectable } from '@angular/core';
import {HttpParams } from "@angular/common/http";
import {HttpService} from "../../../services/http.service";

const baseURL: string = 'production/';
const segment: string = 'production-receipts/';

@Injectable({
  providedIn: 'root'
})
export class ProductionReceiptsService {
  constructor(
      private HttpService: HttpService,
  ) {}

  get(params: HttpParams) {
    return this.HttpService.get(baseURL+'read/'+segment, params );
  }
  getUnsynchronised(params: HttpParams) {
    return this.HttpService.get(baseURL+'read/'+segment+'unsynchronised', params );
  }
  getCountUnsynchronised() {
    return this.HttpService.get(baseURL+'read/'+segment+'count/unsynchronised');
  }
  getReceiptTotals(params: HttpParams) {
    return this.HttpService.get(baseURL+'read/'+segment+'receipt-totals', params);
  }
  getInvoiceableProjects(language: string, params: HttpParams) {
    return this.HttpService.get(baseURL+'read/invoiceable-projects/'+language, params );
  }
  getInvoiceableReceiptsCount(params: HttpParams) {
    return this.HttpService.get(baseURL+'read/invoiceable-receipts/count', params );
  }
  getInvoiceableReceipts(language: string, params: HttpParams) {
    return this.HttpService.get(baseURL+'read/invoiceable-receipts/'+language, params );
  }
  calcNewId(plants_id: number) {
    return this.HttpService.get(baseURL+'read/'+segment+'new-id/'+plants_id.toString());
  }
  calcRemainingAmount(orderId: number) {
    return this.HttpService.get(baseURL+'read/'+segment+'remaining-amount/'+orderId.toString());
  }
  isNumberUnique(plantId: number, number: number) {
    return this.HttpService.get(baseURL+'read/'+segment+'number-unique/'+plantId.toString()+'/'+number);
  }
  create(data: any) {
    return this.HttpService.post(baseURL+'create/'+segment, data);
  }
  update(data: any) {
    return this.HttpService.post(baseURL+'update', data);
  }
  synchronise(data: any) {
    return this.HttpService.post(baseURL+'update/'+segment+'synchronise', data);
  }
  dropReceipt(data: any) {
    return this.HttpService.post('drop_receipts/update', data);
  }
  remove(receipt_id: number) {
    return this.HttpService.get(baseURL+'delete/'+segment+receipt_id.toString(),null );
  }
}
